import { twMerge } from "tailwind-merge";
import { usePopupAnimation } from "@hooks/usePopupAnimation";

const STYLE_VARIANTS = {
  default:
    "bg-white border-secondary-100 dark:border-white/20 dark:bg-tertiary-950",
  inverted: "bg-secondary-700 text-white border-white/20",
};

interface DropdownProps {
  id: string;
  isOpen: boolean;
  children: React.ReactNode;
  className?: string;
  variant?: keyof typeof STYLE_VARIANTS;
}

export const DropdownMenu = ({
  id,
  isOpen,
  children,
  className: styleOverride,
  variant = "default",
}: DropdownProps) => {
  const { isVisible, shouldRender } = usePopupAnimation(isOpen);

  if (!shouldRender) return null;
  return (
    <div
      className={twMerge(
        "overflow-hidden rounded-md border transition-opacity duration-300 dark:border-white/20 dark:bg-tertiary-950",
        "absolute top-8 right-0 z-50",
        isVisible ? "opacity-100" : "opacity-0",
        STYLE_VARIANTS[variant],
        styleOverride
      )}
      data-testid={id}
    >
      <div className="flex w-60 flex-col py-2">{children}</div>
    </div>
  );
};
